import Form from '@utils/form'
import tableSelect from './config/tableSelect'

export default new Form('ordersupplier.externalcontrol')
  .url('/srmCheckApply/saveCheckApply', process.env.VUE_APP_PURCHASE_API)
  .title('formTitle.baseInfo')
  .add('applyDate').merge('date').label('applyDate').required()
  .add('purOfficeNo').select('/purchaseUnit/getPurchaseUnitPage', { usingFlag: '1' }).required()
  .table('bodyList', tableSelect).listRequired()
  .end()
